import React from "react";
import LoadingGif from "../../icons/Bean-Eater-Loaing.svg";

export default function LoadingScreen(){
  return <div className="centered-div"> <img src={LoadingGif} alt="Loading Gif" /> </div>
}
